import {Component} from 'react';
import ReactTable from "react-table";
import "react-table/react-table.css";
import React from "react";
import Badge from 'react-bootstrap/lib/Badge';
import request from 'request-promise-native';
import LoadingModal from "../modals/LoadingModal";
import ValidatedFormComponent from "../ValidatedFormComponent";
import Col from 'react-bootstrap/lib/Col';
import Button from 'react-bootstrap/lib/Button';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import Tooltip from 'react-bootstrap/lib/Tooltip';
import YesNoDialog from "../modals/YesNoDialog";
import SuccessDialog from "../modals/SuccessDialog";
import FailedDialog from "../modals/FailedDialog";
import FormDialog from "../modals/FormDialog";
import Alert from "react-bootstrap/lib/Alert";
import AzureTable from "../AzureTable";

const GET_FIRMWARE_LIST = "https://flexa-firmware.azurewebsites.net/api/GetFirmwareList";
const DELETE_FIRMWARE = "https://flexa-firmware.azurewebsites.net/api/FirmwareRemove";
const UPDATE_FIRMWARE = "https://flexa-firmware.azurewebsites.net/api/FirmwareUpdate";
const ADD_FIRMWARE = "https://flexa-firmware.azurewebsites.net/api/FirmwareCreate";

class ListFirmwaresTab extends Component {

    constructor(props) {
        /*
            Props:
             - access_code
             - logout
        */
        super(props);

        this.state = {
            addFirmwareOpen: false,
            addingFirmware: false,
            addFirmwareSuccess: null,
            addFirmwareFailed: null,

            deleteFirmwareOpen: false,
            deleteFirmware: null,
            deletingFirmware: false,
            deleteFirmwareSuccess: null,
            deleteFirmwareFailed: null,

            updateFirmwareOpen: false,
            updateFirmware: null,
            updatingFirmware: false,
            updateFirmwareSuccess: null,
            updateFirmwareFailed: null,

            firmwares: null,
            loading: true,

            searchButton: true,

            tableLoading: false,
            pages: 1,
            page: 0
        };

        this.pageCache = null;

        this.currentSearch = null;
        //this.loadDevices.bind(this)();
    }

    async fetchData(state,instance) {
        console.log("State: ",state);
        console.log("Instance: ",instance);

        const sort = state.sorted[0];

        console.log("Sort:",sort);

        if(sort.desc!==this.currentOrderDesc) {
            this.currentOrderDesc = sort.desc;
            this.pageCache = null;
            this.setState({
                page: 0
            });
        }

        this.setState({
            tableLoading: true
        });

        if(this.pageCache==null) {
            const options = {
                method: 'POST',
                uri: GET_FIRMWARE_LIST,
                body: {
                    access_code: this.props.access_code,
                    descending: sort.desc,
                    search: this.currentSearch
                },
                json: true,
                resolveWithFullResponse: true,
                simple: false
            };

            const response = await request(options);

            if(response.statusCode!=200) {
                console.log('Logging out!');
                this.props.logout();
                return;
            }

            this.pageCache = [];
            this.pageCache[0] = response.body;

            if(response.body[0]==null || response.body[0].last) {
                this.setState({
                    firmwares: response.body,
                    tableLoading: false,
                    loading: false,
                    pages: 1
                });
            } else {
                this.setState({
                    firmwares: response.body,
                    tableLoading: false,
                    loading: false,
                    pages: 2
                });
            }

            console.log("Cards request success");
        } else {
            if(this.pageCache[state.page]!=null) {
                this.setState({
                    firmwares: this.pageCache[state.page],
                    tableLoading: false,
                    loading: false
                });
            } else {

                let lastName = null;

                if(this.pageCache[state.page-1]!=null) {
                    const page = this.pageCache[state.page-1];
                    console.log("Page: "+(state.page-1), page);
                    lastName = page[9].name;
                }
                console.log("Last NAME: "+lastName);

                const options = {
                    method: 'POST',
                    uri: GET_FIRMWARE_LIST,
                    body: {
                        access_code: this.props.access_code,
                        lastName,
                        descending: sort.desc,
                        search: this.currentSearch
                    },
                    json: true,
                    resolveWithFullResponse: true,
                    simple: false
                };

                const response = await request(options);

                if(response.statusCode!=200) {
                    console.log('Logging out!');
                    this.props.logout();
                    return;
                }

                this.pageCache[state.page] = response.body;

                if(response.body[0]==null || response.body[0].last) {
                    this.setState({
                        firmwares: response.body,
                        tableLoading: false,
                        loading: false,
                        pages: state.page+1
                    });
                } else {
                    this.setState({
                        firmwares: response.body,
                        tableLoading: false,
                        loading: false,
                        pages: state.page+2
                    });
                }


                console.log("Cards request success");
            }
        }

    }

    async deleteFirmware(firmware) {
        const options = {
            method: 'POST',
            uri: DELETE_FIRMWARE,
            body: {
                access_code: this.props.access_code,
                firmwareId: firmware.id
            },
            json: true,
            resolveWithFullResponse: true,
            simple: false
        };

        const response = await request(options);

        if(response.statusCode===200) {
            this.resetTable();
            this.setState({
                deleteFirmwareSuccess: response.body,
                deletingFirmware: false
            });
            return;
        }

        if(response.statusCode===404) {
            this.props.logout();
            return;
        }

        this.setState({
            deleteFirmwareFailed: response.body,
            deletingFirmware: false
        });
    }

    resetTable() {
        this.pageCache = null;
        this.setState({
            page: 0
        },() => {
            this.fetchData.bind(this)({
                sorted: [
                    {
                        desc: this.currentOrderDesc
                    }
                ]
            },null);
        });
    }

    async addFirmware(name,version, alias, changelog) {

        let ver = parseInt(version);

        if(isNaN(ver)) ver = null;

        const f = this.fileInputRef.files[0];
        console.log(this.fileInputRef.files);
        console.log(f);
        const extArr = f.name.split(".");
        const extension = extArr[extArr.length-1];

        this.setState({
            addingFirmware: true,
            addFirmwareSuccess: null,
            addFirmwareFailed: null
        });

        const options = {
            method: 'POST',
            uri: ADD_FIRMWARE,
            body: {
                access_code: this.props.access_code,
                name,
                version: ver,
                alias,
                changelog,
                extension
            },
            json: true,
            resolveWithFullResponse: true,
            simple: false
        };

        const response = await request(options);

        if(response.statusCode===200) {

            const message = response.body.msg;

            this.setState({
                addFirmwareSuccess: "Uploading..."
            });

            const account = {
                name: response.body.name,
                sas:  response.body.sas //"st=2018-10-10T15%3A48%3A23Z&se=2018-10-11T15%3A48%3A23Z&sp=w&sv=2018-03-28&sr=c&sig=ucJ%2F7cSHCSYi1ZkKgimuX5j0c1l6FFjrK27aOcAETQ0%3D"
            };

            console.log(account);

            const blobUri = 'https://' + account.name + '.blob.core.windows.net';
            const blobService = window.AzureStorage.Blob.createBlobServiceWithSas(blobUri, account.sas);

            const speedSummary = blobService.createBlockBlobFromBrowserFile(response.body.container,
                response.body.filename,
                f,
                {blockSize : 512*1024},
                (error, result, response) => {
                    console.log(error);
                    console.log(result);
                    console.log(response);
                    if(error) {
                        // Handle blob error
                        this.setState({
                            addFirmwareSuccess: "Upload has failed! Please retry!",
                            addingFirmware: false,
                        });
                        console.log('Upload failure',error);
                    } else {
                        this.setState({
                            addFirmwareSuccess: message,
                            addingFirmware: false,
                        });
                        this.resetTable();
                        console.log('Upload is successful');
                    }
                });
            return;
        }

        if(response.statusCode===404) {
            this.props.logout();
        }

        this.setState({
            addFirmwareFailed: response.body,
            addingFirmware: false,
        });

    }

    async updateFirmware(firmware,version, changelog) {

        console.log("VERSION, ",version);

        let ver = parseInt(version);

        console.log("VER, ",ver);

        if(isNaN(ver)) ver = null;

        const f = this.fileInputRef.files[0];
        console.log(this.fileInputRef.files);
        console.log(f);
        const extArr = f.name.split(".");
        const extension = extArr[extArr.length-1];

        this.setState({
            updatingFirmware: true,
            updateFirmwareSuccess: null,
            updateFirmwareFailed: null
        });

        const options = {
            method: 'POST',
            uri: UPDATE_FIRMWARE,
            body: {
                access_code: this.props.access_code,
                firmwareId: firmware.id,
                version: ver,
                extension,
                changelog
            },
            json: true,
            resolveWithFullResponse: true,
            simple: false
        };

        const response = await request(options);

        if(response.statusCode===200) {

            const message = response.body.msg;

            this.setState({
                updateFirmwareSuccess: "Uploading..."
            });

            const account = {
                name: response.body.name,
                sas:  response.body.sas //"st=2018-10-10T15%3A48%3A23Z&se=2018-10-11T15%3A48%3A23Z&sp=w&sv=2018-03-28&sr=c&sig=ucJ%2F7cSHCSYi1ZkKgimuX5j0c1l6FFjrK27aOcAETQ0%3D"
            };

            console.log(account);

            const blobUri = 'https://' + account.name + '.blob.core.windows.net';
            const blobService = window.AzureStorage.Blob.createBlobServiceWithSas(blobUri, account.sas);

            const speedSummary = blobService.createBlockBlobFromBrowserFile(response.body.container,
                response.body.filename,
                f,
                {blockSize : 512*1024},
                (error, result, response) => {
                    console.log(error);
                    console.log(result);
                    console.log(response);
                    if(error) {
                        // Handle blob error
                        this.setState({
                            updateFirmwareSuccess: "Upload has failed! Please retry!",
                            updatingFirmware: false,
                        });
                        console.log('Upload failure',error);
                    } else {
                        this.setState({
                            updateFirmwareSuccess: message,
                            updatingFirmware: false,
                        });
                        this.resetTable();
                        console.log('Upload is successful');
                    }
                });
            return;
        }

        if(response.statusCode===404) {
            this.props.logout();
        }

        this.setState({
            updateFirmwareFailed: response.body,
            updatingFirmware: false,
        });

    }

    render() {
        if(!this.props.open) return null;
        return (
            <div className="page-wrapper">
                <div className="page-breadcrumb">
                    <div className="row">
                        <div className="col-12 d-flex no-block align-items-center">
                            <h3 className="page-title"><i className="mdi mdi-folder"></i> Firmwares</h3>
                            <div className="ml-auto text-right">
                                <button className="btn btn-primary" onClick = {() => this.setState({addFirmwareOpen: true})}>
                                    <i className="mdi mdi-plus font-16"></i>Add Firmware
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <YesNoDialog open={this.state.deleteFirmwareOpen}
                             title="Delete firmware"
                             text={(
                                <div>
                                    Do you really want to delete this firmware?<br/>
                                    <b>Name:</b> {this.state.deleteFirmware ? this.state.deleteFirmware.name : ""}<br/>
                                    <b>ID:</b> {this.state.deleteFirmware ? this.state.deleteFirmware.id : ""}
                                </div>
                             )}
                             onYes={() => {
                                 this.deleteFirmware.bind(this)(this.state.deleteFirmware);
                                 this.setState({
                                     deleteFirmwareOpen: false,
                                     deleteFirmware: null,
                                     deletingFirmware: true
                                 });
                             }}
                             onNo={() => {
                                 this.setState({
                                     deleteFirmwareOpen: false,
                                     deleteFirmware: null
                                 });
                             }}
                            />
                <LoadingModal open={this.state.deletingFirmware}
                                title="Deleting firmware..."
                />
                <FailedDialog open={!!this.state.deleteFirmwareFailed}
                              onClose={() => this.setState({deleteFirmwareFailed:null})}
                              title="Delete failed"
                              text={this.state.deleteFirmwareFailed}/>
                <SuccessDialog open={!!this.state.deleteFirmwareSuccess}
                               onClose={() => this.setState({deleteFirmwareSuccess:null})}
                               title="Delete success"
                               text={this.state.deleteFirmwareSuccess}/>

                <FormDialog open={this.state.addFirmwareOpen}
                            onClose={() => {
                                this.setState({
                                    addFirmwareOpen:false,
                                    addFirmwareFailed: false,
                                    addFirmwareSuccess: false
                                })
                            }}
                            titleText="Add firmware"
                            submitText="Add firmware"
                            inputs={[
                                {
                                    onValidate: (value) => {
                                        return value==="" ? "Name cannot be empty!" : (!/^[a-zA-Z0-9 _-]*$/.test(value) ? "Only numbers, letters, -, _ and spaces are allowed!" : null);
                                    },
                                    name: "Name",
                                    type: "text",
                                    placeholder: "Enter firmware name"
                                },
                                {
                                    onValidate: (value) => {
                                        return value==="" ? "Alias cannot be empty!" : (/[^A-Za-z0-9]+/.test(value) ? "Only numbers and letters are allowed!" : null);
                                    },
                                    name: "Alias",
                                    type: "text",
                                    placeholder: "Alias used for the firmware"
                                },
                                {
                                    onValidate: (value) => {
                                        const arr = value.split(".");
                                        if(arr.length<=4) {
                                            for(let str of arr) {
                                                if(str.length!==1) {
                                                    return "Must be in x.x.x.x format!"
                                                }
                                                if(isNaN(parseInt(str))) return str+" is not a number";
                                            }
                                        } else {
                                            return "Must be in x.x.x.x format!"
                                        }
                                        return null;
                                    },
                                    name: "Version",
                                    type: "text",
                                    placeholder: "Firmware version in format x.x.x.x",
                                    emptyAllowed: true
                                },
                                {
                                    onValidate: (value) => {
                                        return value.length>500 ? "Description too long, maximum is 500 characters!" : null;
                                    },
                                    name: "Changelog",
                                    type: "textarea",
                                    placeholder: "Enter firmware changelog"
                                },
                                {
                                    onValidate: (value) => {
                                        return value==="" ? "File cannot be empty!" : null;
                                    },
                                    name: "File",
                                    type: "file",
                                    inputRef: ref => {
                                        this.fileInputRef = ref;
                                    },
                                    placeholder: "Add firmware file"
                                }
                            ]}
                            onSubmit={(obj) => {
                                const name = obj["Name"];
                                console.log("Adding firmware with name: "+name);
                                let ver = 0;
                                const arr = obj["Version"].split(".");

                                for(let i = 0;i<arr.length;i++) {
                                    if(arr[arr.length-i-1].length===1) {
                                        let val = parseInt(arr[arr.length-i-1]);
                                        if(!isNaN(val)) {
                                            ver += val*Math.pow(10,i);
                                        }
                                    }
                                }

                                console.log("Adding firmware version: "+ver);

                                this.addFirmware.bind(this)(name,ver,obj["Alias"],obj["Changelog"]);
                            }}
                            notification={this.state.addFirmwareSuccess ? (<Alert bsStyle="success"><strong>{this.state.addFirmwareSuccess}</strong></Alert>) : this.state.addFirmwareFailed ? (<Alert bsStyle="danger"><strong>{this.state.addFirmwareFailed}</strong></Alert>) : ""}
                            loading={this.state.addingFirmware}/>

                <FormDialog open={this.state.updateFirmwareOpen}
                            onClose={() => {
                                this.setState({
                                    updateFirmwareOpen:false,
                                    updateFirmwareFailed: false,
                                    updateFirmwareSuccess: false,
                                    updateFirmwareVersion: null
                                })
                            }}
                            titleText="Update firmware"
                            submitText="Update firmware"
                            inputs={[
                                {
                                    onValidate: (value) => {
                                        const arr = value.split(".");
                                        if(arr.length<=4) {
                                            for(let str of arr) {
                                                if(str.length!==1) {
                                                    return "Must be in x.x.x.x format!"
                                                }
                                                if(isNaN(parseInt(str))) return str+" is not a number";
                                            }
                                        } else {
                                            return "Must be in x.x.x.x format!"
                                        }
                                        return null;
                                    },
                                    value: this.state.updateFirmwareVersion!=null ? this.state.updateFirmwareVersion : this.state.updateFirmware!=null ? this.state.updateFirmware.version : "0.0.0.0",
                                    onChange: (value) => {
                                        this.setState({
                                            updateFirmwareVersion: value
                                        });
                                    },
                                    name: "Version",
                                    type: "text",
                                    placeholder: "Firmware version in format x.x.x.x",
                                    emptyAllowed: true
                                },
                                {
                                    onValidate: (value) => {
                                        return value.length>500 ? "Description too long, maximum is 500 characters!" : null;
                                    },
                                    name: "Changelog",
                                    type: "textarea",
                                    placeholder: "Enter firmware changelog"
                                },
                                {
                                    onValidate: (value) => {
                                        return value==="" ? "File cannot be empty!" : null;
                                    },
                                    name: "File",
                                    type: "file",
                                    inputRef: ref => {
                                        this.fileInputRef = ref;
                                    },
                                    placeholder: "Add firmware file"
                                }
                            ]}
                            onSubmit={(obj) => {
                                let verStr = this.state.updateFirmwareVersion!=null ? this.state.updateFirmwareVersion : this.state.updateFirmware!=null ? this.state.updateFirmware.version : "0.0.0.0";
                                console.log("Firmware version",verStr);

                                let ver = 0;
                                const arr = verStr.split(".");

                                for(let i = 0;i<arr.length;i++) {
                                    if(arr[arr.length-i-1].length===1) {
                                        let val = parseInt(arr[arr.length-i-1]);
                                        if(!isNaN(val)) {
                                            ver += val*Math.pow(10,i);
                                        }
                                    }
                                }

                                console.log("Update firmware version: "+ver);

                                this.updateFirmware.bind(this)(this.state.updateFirmware, ver, obj["Changelog"]);
                                this.setState({
                                    updateFirmwareVersion: null
                                });
                            }}
                            notification={this.state.updateFirmwareSuccess ? (<Alert bsStyle="success"><strong>{this.state.updateFirmwareSuccess}</strong></Alert>) : this.state.updateFirmwareFailed ? (<Alert bsStyle="danger"><strong>{this.state.updateFirmwareFailed}</strong></Alert>) : ""}
                            loading={this.state.updatingFirmware}/>

                <div className="mt-4">
                    <Col sm={4} xs={8}>
                        <ValidatedFormComponent
                            type="text"
                            placeholder="Search"
                            onValidate={input => {
                                return null;
                            }}
                            inputRef={ref => this.searchRef=ref}
                            onChange={input => {
                                if(input==='' && this.currentSearch!=null) {
                                    this.setState({
                                        searchButton: false
                                    });
                                    return;
                                }

                                if(input!==this.currentSearch) {
                                    if(!this.state.searchButton) this.setState({
                                        searchButton: true
                                    })
                                }
                                if(input===this.currentSearch) {
                                    if(this.state.searchButton) this.setState({
                                        searchButton: false
                                    });
                                }
                            }}
                        />
                    </Col>
                    {this.state.searchButton ? (<Button bsStyle="success" onClick={() => {
                        if(this.searchRef.value!=='') {
                            if(this.currentSearch === this.searchRef.value) return;
                            this.setState({
                                searchButton: false
                            });
                            this.currentSearch = this.searchRef.value;
                            this.resetTable();
                        }
                    }}>
                        <i className="fa fa-search"/>
                    </Button>) : (<Button bsStyle="danger" onClick={() => {
                        if(this.currentSearch) {
                            this.currentSearch = null;
                            this.setState({
                                searchButton: true
                            });
                            this.resetTable();
                        }
                    }}>
                        <i className="fa fa-window-close"/>
                    </Button>)}

                </div>
                <div className="container-fluid">
                    <ReactTable
                        loading={this.state.tableLoading}
                        data={this.state.firmwares==null ? [] : this.state.firmwares}
                        /*getTdProps={(state, rowInfo, column, instance) => {
                            if(rowInfo!=null && column.Header!=='Delete' && column.Header!=="") return {
                                style: {
                                    cursor: 'pointer'
                                },
                                onClick: e => {
                                    console.log("Cell - onClick", rowInfo.original);
                                    this.setState({
                                        addDeviceOpen: true,
                                        editDevice: rowInfo.original
                                    });
                                }
                            };
                            return {};
                        }}*/
                        SubComponent={(row) => {
                            if(row.original.versions==null) return (
                                <div className="mx-4 my-4">
                                    <h4>No previous versions found!</h4>
                                </div>
                            );

                            return (
                                <div className="mx-4 my-4">
                                    <ReactTable
                                        sortable={false}
                                        filterable={false}
                                        pageSize={10}
                                        data={row.original.versions}
                                        columns={[
                                            {
                                                Header:"Version",
                                                accessor: "version",
                                                maxWidth: 100,
                                                Cell: row2 => {
                                                    let ver = row2.original.version;
                                                    let verStr = [];
                                                    for(let i=3;i>=0;i--) {
                                                        let num = Math.floor(ver/(Math.pow(10, i)));
                                                        ver = ver % Math.pow(10, i);
                                                        verStr.push(num);
                                                    }
                                                    return verStr.join(".");
                                                }
                                            },
                                            {
                                                Header:"URL",
                                                Cell: row2 => {
                                                    return (
                                                        <a href={row2.original.url}>
                                                            {row2.original.url}
                                                        </a>
                                                    );
                                                },
                                                maxWidth: 300,
                                            },
                                            {
                                                Header: "Changelog",
                                                accessor: "changelog"
                                            }
                                        ]}
                                    />
                                </div>
                            );
                        }}
                        columns={[
                            {
                                Header: "Name",
                                accessor: "name"
                            },
                            {
                                Header: "ID (alias)",
                                accessor: "id",
                                sortable: false
                            },
                            {
                                Header: "Version",
                                accessor: "version",
                                width: 64,
                                sortable: false,
                                Cell: row => {
                                    let ver = row.original.version;
                                    let verStr = [];
                                    for(let i=3;i>=0;i--) {
                                        let num = Math.floor(ver/(Math.pow(10, i)));
                                        ver = ver % Math.pow(10, i);
                                        verStr.push(num);
                                    }
                                    return verStr.join(".");
                                }
                            },
                            {
                                Header: "Firmware URL",
                                Cell: row => {
                                    return (
                                        <a href={row.original.url}>
                                            {row.original.url}
                                        </a>
                                    );
                                },
                                sortable: false
                            },
                            {
                                Header: "Update",
                                width: 64,
                                maxWidth: 64,
                                Cell: row => (
                                    <OverlayTrigger placement="top" overlay={(
                                        <Tooltip id={"tooltip"+row.original.id}>
                                            <strong>Update firmware!</strong>
                                        </Tooltip>
                                    )}>
                                        <a href="#" onClick={() => {
                                            let firmware = {...row.original};

                                            firmware.version++;

                                            let ver = firmware.version;
                                            let verStr = [];
                                            for(let i=3;i>=0;i--) {
                                                let num = Math.floor(ver/(Math.pow(10, i)));
                                                ver = ver % Math.pow(10, i);
                                                verStr.push(num);
                                            }

                                            firmware.version = verStr.join(".");

                                            this.setState({
                                                updateFirmwareOpen: true,
                                                updateFirmware: firmware
                                            })
                                            console.log(firmware);
                                        }}><i className="fa fa-cloud-upload-alt"></i></a>
                                    </OverlayTrigger>
                                ),
                                sortable: false
                            },
                            {
                                Header: "Delete",
                                width: 64,
                                maxWidth: 64,
                                Cell: row => (
                                    <OverlayTrigger placement="top" overlay={(
                                        <Tooltip id={"tooltip"+row.original.id}>
                                            <strong>Delete firmware!</strong>
                                        </Tooltip>
                                    )}>
                                        <a href="#" onClick={() => {
                                            this.setState({
                                                deleteFirmwareOpen: true,
                                                deleteFirmware: row.original
                                            })
                                            console.log(row.original);
                                        }}><i className="fa fa-trash"></i></a>
                                    </OverlayTrigger>
                                ),
                                sortable: false
                            }
                        ]}
                        defaultSorted={[
                            {
                                id: "name",
                                desc: false
                            }
                        ]}
                        manual
                        pageText={""}
                        ofText={""}
                        pages={this.state.pages}
                        page={this.state.page}
                        onPageChange={(pageIndex) => this.setState({
                            page: pageIndex
                        })}
                        onFetchData={this.fetchData.bind(this)}
                        showPageJump={false}
                        showPageSizeOptions={false}
                        defaultPageSize={10}
                        className="-striped -highlight"
                        collapseOnDataChange={false}
                    />
                </div>
            </div>
        );
    }
}

export default ListFirmwaresTab;